export const standardFilterFields = [
	'jobId',
	'transactionId',
	//
	'countryCode',
	'organizationId',
	'clientId',
	'allocationType',
	//
	'builderId',
	'customerId',
	'projectId',
	//
	'jobType',
	'requestType',
	'requirements',
	//
	'createdBy',
	'owner',
	'salesPerson',
	//
	'difficultyRating',
	//
	'assignedTo',
	//
	'statusCategory',
	'status',
] as const;

export const dateFilterFields = ['createdAt', 'targetAt', 'dueAt', 'designEndedAt'] as const;

export const stageStatusFilterFields = ['stageStatus'] as const;

export const filterFields = [
	...standardFilterFields,
	...dateFilterFields,
	...stageStatusFilterFields,
] as const;
